import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NavigationProviderService } from '@prcins/utils';
import { BRAND, Brand, ADMIN } from '@prcins/constants';

@Component({
  selector: 'prcins-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.css']
})
export class MobileHeaderComponent implements OnInit {
  @Input() menus;
  @Input() activeMenus;
  @Input() selectedHeader;
  @Output() logOut = new EventEmitter();
  @Output() softLogOut = new EventEmitter();


  isAdmin;

  brand = localStorage.getItem(BRAND);
  mainPage = Brand[this.brand].urlEnterpriseWeb;

  navMenu;

  showNavigationPanel = false;

  constructor(private navigationProvider: NavigationProviderService) { }

  ngOnInit(): void {
    this.navMenu = this.activeMenus;
    this.isAdmin = sessionStorage.getItem(ADMIN) === 'Y';
  }

  menuNavigationHandler(methodName) {
    this.navigationProvider[methodName]();
  }

  toggleNavMenu() {
    this.showNavigationPanel = !this.showNavigationPanel;
  }

  showSubMenu(menuFlag) {
    const val = !this.navMenu[menuFlag];
    this.navMenu = {
      ...this.activeMenus,
      [menuFlag]: val
    };
  }

  onMenuClick(menu) {
    this.showNavigationPanel = false;
    this.navMenu = {
      ...this.activeMenus
    };
  }

  onLogout(): void {
    this.logOut.next();
  }

  onSoftLogout(): void {
    this.softLogOut.next();
  }

  showLink(subMenu) {
    if (!subMenu.route) {
      return false;
    }

    if (subMenu.disable) {
      if (subMenu.waitConditionally) {
        return true;
      } else {
        return false;
      }

    } else {
      return true;
    }

  }
}
